"use client"

import { extractTwitterId } from "@/(admin)/modules/ui-builder/config/lib/twitter-helpers";
import { extractYouTubeId, getYouTubeEmbedUrl } from "@/(admin)/modules/ui-builder/config/lib/youtube-helpers";
import { buildTwitterSrcDoc } from "@/utils/build-twitter-src-doc";
import { X } from "lucide-react";
import { useMemo } from "react";

type VideoModalProps = {
  isOpen: boolean
  videoUrl: string
  onClose: () => void
}

export default function VideoModal({ isOpen, videoUrl, onClose }: VideoModalProps) {
  if (!isOpen) return null

  const ytId = extractYouTubeId(videoUrl)
  const twId = extractTwitterId(videoUrl)

  const embedUrl = useMemo(() => {
    if (ytId) return getYouTubeEmbedUrl(ytId);
    return "";
  }, [ytId]);

  const twitterSrcDoc = useMemo(() => {
    if (twId) return buildTwitterSrcDoc(videoUrl);
    return "";
  }, [twId, videoUrl]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75" onClick={onClose}>
      <div
        className="relative w-full max-w-[1212px] mx-4 flex flex-col gap-4 p-4 bg-white rounded-2xl overflow-hidden"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h3 className="text-base leading-4 font-normal">TAMDA PLAYER</h3>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800 text-2xl font-bold leading-none"
            aria-label="Close"
          >
            <X className="w-4 h-4" strokeWidth={1} />
          </button>
        </div>

        <div className="relative w-full"
          style={twId ? { height: '70vh', minHeight: '500px' } : { paddingBottom: "56.25%", maxHeight: '70vh' }}>
          {ytId && embedUrl ? (
            <iframe
              src={embedUrl}
              className="absolute top-0 left-0 w-full h-full border-0 bg-black"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : twId && twitterSrcDoc ? (

            <iframe
              srcDoc={twitterSrcDoc}
              className="absolute top-0 left-0 w-full h-full border-0 rounded-xl bg-white"
              sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 text-gray-400 rounded-xl">
              Không thể phát nội dung này
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
